import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import GlobalContext from '../contexts/GlobalContext';

dayjs.extend(timezone);
dayjs.extend(utc);

const useServerTime = () => {
	const { serverTimestamp, serverTimezone } = React.useContext(GlobalContext);

	const [serverTimeDisplay, setServerTimeDisplay] = React.useState<string | null>(null);

	React.useEffect(() => {
		if (!serverTimestamp || !serverTimezone) {
			setServerTimeDisplay(null);
			return;
		}

		let serverTime = dayjs(serverTimestamp).tz(serverTimezone);

		const timeTicker = () => {
			serverTime = serverTime.add(1, 'second');
			setServerTimeDisplay(serverTime.format('hh:mm:ss A Z'));
		};

		timeTicker();
		const intervalRef = setInterval(timeTicker, 1000);

		return () => {
			clearInterval(intervalRef);
		};
	}, [serverTimestamp, serverTimezone]);

	return serverTimeDisplay;
};

export default useServerTime;
